import type {
    BookingBusinessEntry,
    BookingBusinessEntryInput,
    BookingWorkHours,
    BookingSchedulingPolicy,
    BookingSettings,
    BookingPostalAddress,
} from 'owa-graph-schema';
import mapToBookingSchedulingPolicyInput from './mapToBookingSchedulingPolicyInput';
import mapToBookingWorkHoursInput from './mapToBookingWorkHoursInput';
import mapToBookingSettingsInput from './mapToBookingSettingsInput';
import mapToBookingPostalAddressInput from './mapToBookingPostalAddressInput';

const mapToBookingBusinessEntryInput = (
    businessEntry: BookingBusinessEntry
): BookingBusinessEntryInput => {
    const {
        displayName,
        email,
        businessType,
        defaultCurrencyIso,
        phone,
        websiteUrl,
        address,
        businessHours,
        schedulingPolicy,
        isPublished,
        id,
        currencySymbol,
        businessLanguage,
        businessTimeZone,
        settings,
        privacyPolicyUrl,
        termsAndConditionsUrl,
        businessName,
    } = businessEntry;

    const modifiedBusinessEntry: BookingBusinessEntryInput = {
        displayName,
        email,
        businessType,
        defaultCurrencyIso,
        phone,
        websiteUrl,
        isPublished,
        id,
        currencySymbol,
        businessLanguage,
        businessTimeZone,
        privacyPolicyUrl,
        termsAndConditionsUrl,
        address: mapToBookingPostalAddressInput(address as BookingPostalAddress),
        businessHours: mapToBookingWorkHoursInput(businessHours as BookingWorkHours[]),
        schedulingPolicy: mapToBookingSchedulingPolicyInput(
            schedulingPolicy as BookingSchedulingPolicy
        ),
        settings: mapToBookingSettingsInput(settings as BookingSettings),
        businessName,
    };
    return modifiedBusinessEntry;
};

export default mapToBookingBusinessEntryInput;
